import type { ExerciseRepetition } from "types";
import type { BaseExercise } from "types/output-exercise";
import { ProfileType } from "components/charting/hooks/useProfileTypeQueryState";

const profileTypeRepMetricFieldMap: Record<ProfileType, string> = {
  [ProfileType.Velocity]: "meanVelocity",
  [ProfileType.Power]: "meanPower",
};

class AthleteProfileChartHelpers {
  static getProfileTypeRepMetric(
    exercise: Pick<BaseExercise, "repetitions"> | null | undefined,
    profileType: ProfileType
  ): ExerciseRepetition | null {
    const field = profileTypeRepMetricFieldMap[profileType];
    return exercise?.repetitions.find((repetition) => repetition.field === field) ?? null;
  }
}

export default AthleteProfileChartHelpers;
